<template>
  <div>
    <div class="c4-scrim" :class="{ on: open }" @click="$emit('close')"></div>
    <div
      class="c4-sheet"
      :class="{ on: open }"
      role="dialog"
      aria-modal="true"
      :aria-hidden="open ? 'false' : 'true'"
      :aria-label="title"
    >
      <div class="c4-grip"><i></i></div>
      <div class="c4-sh-h">
        <div>
          <div class="c4-sh-t">{{ title }}</div>
          <div v-if="subtitle" class="c4-sh-s">{{ subtitle }}</div>
        </div>
        <button ref="close" type="button" class="c4-ib" data-fk="x" :aria-label="tx('close')" @click="$emit('close')">
          <i class="mdi mdi-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="c4-sh-b"><slot></slot></div>
      <div v-if="$scopedSlots.footer" class="c4-sh-f"><slot name="footer"></slot></div>
    </div>
  </div>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenSheet",
  mixins: [canteenV4Text],
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        this.previous = document.activeElement;
        this.$nextTick(() => {
          if (this.$refs.close) this.$refs.close.focus({ preventScroll: true });
        });
      } else if (this.previous && this.previous.focus && document.contains(this.previous)) {
        this.previous.focus({ preventScroll: true });
        this.previous = null;
      }
    },
  },
};
</script>
